import createIcon from './utils/createIcon.js';
import '@babel/runtime/helpers/esm/extends';
import 'react';
import './utils/SvgIcon.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react-desc';
import '@elliemae/ds-classnames';

/* eslint-disable */
var Comments2 = createIcon({
  paths: ['M.5 19c-.225 0-.422-.15-.482-.367s.032-.447.225-.562c1.691-1.014 2.392-2.489 2.641-3.179C1.046 13.485 0 11.538 0 9.5c0-1.029.258-2.026.768-2.964.486-.894 1.18-1.695 2.061-2.381C4.616 2.765 6.985 1.999 9.5 1.999s4.884.766 6.671 2.156c.881.685 1.575 1.486 2.061 2.381.51.937.768 1.934.768 2.964s-.258 2.026-.768 2.964c-.486.894-1.18 1.695-2.061 2.381-1.787 1.39-4.156 2.156-6.671 2.156-1.033 0-2.047-.129-3.016-.385-.429.286-1.231.793-2.189 1.27-1.488.74-2.764 1.115-3.794 1.115zm9-16C4.813 3 1 5.916 1 9.5c0 1.815 1.005 3.562 2.756 4.792.172.121.25.336.196.539-.117.436-.515 1.633-1.58 2.788 1.302-.456 2.704-1.247 3.739-1.959.123-.085.277-.11.421-.069.948.271 1.947.409 2.968.409 4.687 0 8.5-2.916 8.5-6.5S14.187 3 9.5 3z', 'M13.5 7h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM13.5 9h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM13.5 11h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM11.5 13h-6c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6c.276 0 .5.224.5.5s-.224.5-.5.5z'],
  height: 20,
  width: 20
});

export default Comments2;
//# sourceMappingURL=Comments2.js.map
